<su-headline h="h1" skin="primary">{{
  'menu.tickets_tasks.component.tickets_view' | translate
}}</su-headline>

<div class="row-chips">
  <su-chip [items]="chips" (onRemove)="handleOnRemoveChip($event)"></su-chip>
</div>

<div style="justify-self: flex-end">
  <su-button
    skin="secondary"
    icon="file-excel"
    [label]="'Excel Download'"
    (onClick)="exportToExcel()"
    [disabled]="!canDownload">
  </su-button>
</div>

<ng-template #toolbarTpl>
  <div class="ticket-task-select-container">
    <mat-form-field appearance="outline">
      <mat-label>{{
        'taskmodule.shared.label__ticketTaskSelection' | translate
      }}</mat-label>
      <mat-select
        [formControl]="ticketTaskControl"
        (selectionChange)="onSelectionChange()">
        <mat-option
          *ngFor="let option of ticketTaskOptions"
          [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <su-slot-controls
    [mainTLabel]="'crud.filter' | translate"
    [buttons]="controlButtons"
    [chips]="chips"
    [menuItems]="menuItems"
    [dialogData]="dialogData"
    (onCloseDialog)="onCloseDialog($event)"
    [modal]="modalComponent"></su-slot-controls>
</ng-template>

<mtx-grid
  [columnResizable]="true"
  [columns]="columns"
  [data]="data.items"
  [length]="data.totalCount"
  [pageOnFront]="false"
  [sortOnFront]="config.grid.filter.sortOnFront"
  [loading]="isLoading"
  [rowStriped]="true"
  [noResultText]="'grid.no_results' | translate"
  (rowClick)="clickRowWrapper($event)"
  [rowHover]="false"
  [cellSelectable]="false"
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  (sortChange)="sortChange($event)"
  (page)="getNextPage($event)"
  [pageSize]="config.grid.paging.pageSize"
  [pageIndex]="config.grid.paging.pageIndex"
  [showPaginator]="config.grid.paging.showPaginator"
  [columnMenuButtonText]="'grid.columns_shown' | translate"
  [columnHideable]="true"
  [columnHideableChecked]="'show' | translate"
  columnMenuButtonClass="col-button"
  [showSidebar]="true"
  [expandable]="true"
  (expansionChange)="getTasks($event)"
  [expansionTemplate]="expansionTemplate"
  [showToolbar]="true"
  [columnSortable]="true"
  [showColumnMenuButton]="true"
  columnMenuButtonType="flat"
  [columnPinnable]="false"
  [toolbarTemplate]="toolbarTpl"
  (columnChange)="columnsChanged($event)">
</mtx-grid>

<ng-template #expansionTemplate let-row>
  <div *ngIf="!sysUser">
    <div *ngFor="let task of row.tasks">
      <!------ Meine Tickets mit aktiven Aufgaben----------------------------------------------------------------------------------->
      <div
        class="expansion-item"
        *ngIf="
          $any(this.form.value).ticketTaskSelection ===
          'MyTicketsWithActiveTasks'
        ">
        <div
          *ngIf="
            task.isActive &&
            task.status !== 'Abgeschlossen' &&
            task.status !== 'Storniert' &&
            task.processorId === user.contactId
          ">
          <ng-container>
            <p
              *ngIf="task.organisationId !== user?.organisationId; else first"
              class="disabled space-row">
              {{ task.subject }} ({{ task.status }})
              <span *ngIf="task.processorName">
                - {{ 'taskmodule.shared.label__editor' | translate }}:
                {{ task.processorName }}
              </span>
            </p>
          </ng-container>
          <ng-template #first>
            <p
              *ngIf="
                task.status === 'Abgeschlossen' || task.status === 'Storniert';
                else second
              "
              class="disabled-completed">
              {{ task.subject }} ({{ task.status }})
              <span *ngIf="task.processorName">
                - {{ 'taskmodule.shared.label__editor' | translate }}:
                {{ task.processorName }}
              </span>
            </p>
          </ng-template>
          <ng-template #second>
            <p
              *ngIf="
                task.status !== 'Abgeschlossen' && task.status !== 'Storniert'
              "
              class="enabled space-row"
              role="button"
              tabindex="0"
              [attr.aria-label]="'Aufgabe öffnen: ' + task.subject"
              (click)="clickExpandedRow(task)"
              (keydown.enter)="clickExpandedRow(task)"
              (keydown.space)="clickExpandedRow(task); $event.preventDefault()">
              {{ task.subject }} ({{ task.status }})
              <span *ngIf="task.processorName">
                - {{ 'taskmodule.shared.label__editor' | translate }}:
                {{ task.processorName }}
              </span>
            </p>
          </ng-template>
        </div>
      </div>
      <!------Tickets mit aktiven Aufgaben----------------------------------------------------------------------------------->
      <div
        class="expansion-item"
        *ngIf="
          $any(this.form.value).ticketTaskSelection === 'TicketsWithActiveTasks'
        ">
        <div
          *ngIf="
            task.isActive &&
            task.status !== 'Abgeschlossen' &&
            task.status !== 'Storniert'
          ">
          <ng-container>
            <p
              *ngIf="task.organisationId !== user?.organisationId; else first"
              class="disabled space-row">
              {{ task.subject }} ({{ task.status }})
              <span *ngIf="task.processorName">
                - {{ 'taskmodule.shared.label__editor' | translate }}:
                {{ task.processorName }}
              </span>
              <span *ngIf="task.organisationName">
                - Firma:
                {{ task.organisationName }}
              </span>
            </p>
          </ng-container>
          <ng-template #first>
            <p
              *ngIf="
                task.status === 'Abgeschlossen' || task.status === 'Storniert';
                else second
              "
              class="disabled-completed">
              {{ task.subject }} ({{ task.status }})
              <span *ngIf="task.processorName">
                - {{ 'taskmodule.shared.label__editor' | translate }}:
                {{ task.processorName }}
              </span>
              <span *ngIf="task.organisationName">
                - Firma:
                {{ task.organisationName }}
              </span>
            </p>
          </ng-template>
          <ng-template #second>
            <div class="expandendDivs">
              <div>
                <su-button
                  skin="primary"
                  icon="user"
                  [ngClass]="'contactButton special-button'"
                  [title]="'taskmodule.shared.label__contact' | translate"
                  [ariaLabel]="'taskmodule.shared.label__contact' | translate"
                  (onClick)="openContact($event, task)">
                </su-button>
              </div>
              <div>
                <p
                  *ngIf="
                    task.status !== 'Abgeschlossen' &&
                    task.status !== 'Storniert'
                  "
                  class="enabled space-row"
                  role="button"
                  tabindex="0"
                  [attr.aria-label]="'Aufgabe öffnen: ' + task.subject"
                  (click)="clickExpandedRow(task)"
                  (keydown.enter)="clickExpandedRow(task)"
                  (keydown.space)="clickExpandedRow(task); $event.preventDefault()">
                  {{ task.subject }} ({{ task.status }})
                  <span *ngIf="task.processorName">
                    - {{ 'taskmodule.shared.label__editor' | translate }}:
                    {{ task.processorName }}
                  </span>
                  <span *ngIf="task.organisationName">
                    - Firma:
                    {{ task.organisationName }}
                  </span>
                </p>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <!------Alle Tickets--------------------------------------------------------------------------------------------------->
      <div
        class="expansion-item"
        *ngIf="$any(this.form.value).ticketTaskSelection === 'All'">
        <ng-container>
          <p
            *ngIf="task.organisationId !== user?.organisationId; else first"
            class="disabled space-row">
            {{ task.subject }} ({{ task.status }})
            <span *ngIf="task.processorName">
              - {{ 'taskmodule.shared.label__editor' | translate }}:
              {{ task.processorName }}
            </span>
            <span *ngIf="task.organisationName">
              - Firma:
              {{ task.organisationName }}
            </span>
          </p>
        </ng-container>
        <ng-template #first>
          <p
            *ngIf="
              task.status === 'Abgeschlossen' ||
                (task.status === 'Storniert' &&
                  task.organisationId === user?.organisationId);
              else second
            "
            class="enabled-completed-cancelled space-row"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Aufgabe öffnen: ' + task.subject"
            (click)="clickExpandedRow(task)"
            (keydown.enter)="clickExpandedRow(task)"
            (keydown.space)="clickExpandedRow(task); $event.preventDefault()">
            {{ task.subject }} ({{ task.status }})
            <span *ngIf="task.processorName">
              - {{ 'taskmodule.shared.label__editor' | translate }}:
              {{ task.processorName }}
            </span>
            <span *ngIf="task.organisationName">
              - Firma:
              {{ task.organisationName }}
            </span>
          </p>
        </ng-template>
        <ng-template #second>
          <p
            *ngIf="task.status === 'Abgeschlossen'; else third"
            class="disabled-completed space-row">
            {{ task.subject }} ({{ task.status }})
            <span *ngIf="task.processorName">
              - {{ 'taskmodule.shared.label__editor' | translate }}:
              {{ task.processorName }}
            </span>
            <span *ngIf="task.organisationName">
              - Firma:
              {{ task.organisationName }}
            </span>
          </p>
        </ng-template>
        <ng-template #third>
          <p
            *ngIf="task.status !== 'Abgeschlossen'"
            class="enabled space-row"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Aufgabe öffnen: ' + task.subject"
            (click)="clickExpandedRow(task)"
            (keydown.enter)="clickExpandedRow(task)"
            (keydown.space)="clickExpandedRow(task); $event.preventDefault()">
            {{ task.subject }} ({{ task.status }})
            <span *ngIf="task.processorName">
              - {{ 'taskmodule.shared.label__editor' | translate }}:
              {{ task.processorName }}
            </span>
            <span *ngIf="task.organisationName">
              - Firma:
              {{ task.organisationName }}
            </span>
          </p>
        </ng-template>
      </div>
    </div>
  </div>

  <div *ngIf="sysUser">
    <div *ngFor="let task of row.tasks">
      <!------GSUS: Tickets mit aktiven Aufgaben----------------------------------------------------------------------------------->
      <div
        class="expansion-item"
        *ngIf="
          $any(this.form.value).ticketTaskSelection ===
            'TicketsWithActiveTasks' && checkOrganisation(task, row.ticketClass)
        ">
        <div
          *ngIf="
            task.isActive &&
            task.status !== 'Abgeschlossen' &&
            task.status !== 'Storniert'
          ">
          <ng-container>
            <div class="expandendDivs">
              <div>
                <su-button
                  skin="primary"
                  icon="user"
                  [ngClass]="'contactButton special-button'"
                  [title]="'taskmodule.shared.label__contact' | translate"
                  [ariaLabel]="'taskmodule.shared.label__contact' | translate"
                  (onClick)="openContactDetails($event, task)">
                </su-button>
              </div>
              <p class="enabled space-row">
                {{ task.subject }} ({{ task.status }})
                <span *ngIf="task.processorName">
                  - {{ 'taskmodule.shared.label__editor' | translate }}:
                  {{ task.processorName }}
                </span>
                <span *ngIf="task.organisationName">
                  - Firma:
                  {{ task.organisationName }}
                </span>
              </p>
            </div>
          </ng-container>
        </div>
      </div>
      <!------GSUS: Alle Tickets--------------------------------------------------------------------------------------------------->
      <div
        class="expansion-item"
        *ngIf="$any(this.form.value).ticketTaskSelection === 'All'">
        <ng-container>
          <p
            *ngIf="!checkOrganisation(task, row.ticketClass); else first"
            class="disabled space-row">
            {{ task.subject }} ({{ task.status }})
            <span *ngIf="task.processorName">
              - {{ 'taskmodule.shared.label__editor' | translate }}:
              {{ task.processorName }}
            </span>
            <span *ngIf="task.organisationName">
              - Firma:
              {{ task.organisationName }}
            </span>
          </p>
        </ng-container>
        <ng-template #first>
          <p
            *ngIf="
              task.status === 'Abgeschlossen' ||
                (task.status === 'Storniert' && checkOrganisation(task, row.ticketClass));
              else second
            "
            class="enabled-completed-cancelled space-row"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Aufgabe öffnen: ' + task.subject"
            (click)="clickExpandedRowGSUS(task)"
            (keydown.enter)="clickExpandedRowGSUS(task)"
            (keydown.space)="clickExpandedRowGSUS(task); $event.preventDefault()">
            {{ task.subject }} ({{ task.status }})
            <span *ngIf="task.processorName">
              - {{ 'taskmodule.shared.label__editor' | translate }}:
              {{ task.processorName }}
            </span>
            <span *ngIf="task.organisationName">
              - Firma:
              {{ task.organisationName }}
            </span>
          </p>
        </ng-template>
        <ng-template #second>
          <p
            *ngIf="task.status !== 'Abgeschlossen'"
            class="enabled space-row"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Aufgabe öffnen: ' + task.subject"
            (click)="clickExpandedRowGSUS(task)"
            (keydown.enter)="clickExpandedRowGSUS(task)"
            (keydown.space)="clickExpandedRowGSUS(task); $event.preventDefault()">
            {{ task.subject }} ({{ task.status }})
            <span *ngIf="task.processorName">
              - {{ 'taskmodule.shared.label__editor' | translate }}:
              {{ task.processorName }}
            </span>
            <span *ngIf="task.organisationName">
              - Firma:
              {{ task.organisationName }}
            </span>
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ticketActionsTemplate let-row let-index="index" let-col="colDef">
  <su-button
    [skin]="row.hasDocuments ? 'primary' : 'secondary'"
    icon="paperclip"
    [title]="'documents.title' | translate"
    [ariaLabel]="'documents.title' | translate"
    (onClick)="openDocuments($event, row)">
  </su-button>
</ng-template>

<app-spinner-overlay [show]="loading" label=""></app-spinner-overlay>
